import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { PartnerRelationship } from './models/PartnerRelationship';
import { RelationshipType } from './models/partner';

@Injectable({
  providedIn: 'root'
})
export class PartnershipService {

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  find(): Observable<PartnerRelationship[]> {
    const api = (<any>_GlobalNS).api.relationship.relationship;
    return this._http.get<any>(`${api}`, {});
  }

  findTypes(): Observable<RelationshipType> {
    const api = (<any>_GlobalNS).api.relationship.relationshipType;
    return this._http.get<any>(`${api}`, {});
  }

  findById(RelationshipId: number): Observable<PartnerRelationship[]> {
    const api = (<any>_GlobalNS).api.relationship.relationshipById;
    const params = new HttpParams().set('RelationshipId', RelationshipId.toString());
    return this._http.get<any>(`${api}`, {params});
  }

  findByPerson(PersonId?: number): Observable<PartnerRelationship[]> {
    const api = (<any>_GlobalNS).api.relationship.relationshipByPerson;
    const personId = typeof PersonId === 'number' ? PersonId.toString() : '';
    const params = new HttpParams().set('PersonId', personId);
    return this._http.get<any>(`${api}`, {params});
  }
}
